// extracted by mini-css-extract-plugin
module.exports = {"leave-message__main":"leave-message__main__2qjg1","leave-message__message":"leave-message__message__3XDZW"};